/**
 * @author Ketan Shetye
 * @created 2025-11-03
 * @description applicant home - drawer pages header common component
 */
import { Component, Input } from '@angular/core';
import { ApplicantHomeDrawerHeadingData } from './applicant-home-drawer-heading.component.model';

@Component({
  selector: 'wm-applicant-home-drawer-heading',
  standalone:false,
  templateUrl: './applicant-home-drawer-heading.component.html',
  styleUrl: './applicant-home-drawer-heading.component.scss'
})
export class ApplicantHomeDrawerHeadingComponent {
private _data: ApplicantHomeDrawerHeadingData = {
    header: '',
    subHeader: ''
  };

  @Input({ required: true }) 
  set data(value: ApplicantHomeDrawerHeadingData) {
    this._data = {
      header: '',
    subHeader: '',
      ...value, // merge passed value with defaults
    };
  }

  get data(): ApplicantHomeDrawerHeadingData {
    return this._data;
  }
}
